import { NumberInput, NumberInputProps } from '@mantine/core';
import React from 'react'

export function ENumberInput({ ...props }: NumberInputProps) {
  return <NumberInput
    // hideControls
    radius="md"
    size="md"
    {...props}
  />;
}
